import React, { useCallback, useEffect, useState } from "react";
import { fetchDropStatus, runDropImport } from "../api";
import { Card, Loading } from "./ui";

/**
 * The Deltek drop directory, in Admin.
 *
 * Reports now arrive on their own, which is the point - but an importer that
 * runs unattended and fails quietly is worse than one nobody automated. This
 * shows what is waiting, when the last sweep ran, and whether it worked.
 */
export default function DropStatus() {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  const load = useCallback(() => {
    fetchDropStatus().then(setData).catch((e) => setErr(e.message));
  }, []);

  useEffect(load, [load]);

  const runNow = async () => {
    setBusy(true); setMsg(""); setErr("");
    try {
      const r = await runDropImport("labour");
      setMsg(r.imported
        ? `Imported ${r.rowsInserted} rows, replacing ${r.rowsRemoved}.`
        : "Nothing waiting — the last report has already been taken.");
      load();
    } catch (e) {
      setErr(e.message);
    } finally {
      setBusy(false);
    }
  };

  if (!data && !err) return <Card title="Deltek reports"><Loading label="Checking…" /></Card>;

  const last = data?.lastRun;
  return (
    <Card
      title="Deltek reports"
      note="Vision emails these; the scraper drops them here and the labour import claims its own file automatically"
    >
      {err && <div className="notice notice--bad">{err}</div>}
      {msg && <div className="notice">{msg}</div>}

      <p className="toolbar-note">
        Drop directory <code>{data?.dir}</code>. Swept every 15 minutes.{" "}
        {last
          ? last.ok
            ? `Last sweep ${new Date(last.at).toLocaleString()} — ${last.imported ? "imported a report" : "nothing waiting"}.`
            : `Last sweep ${new Date(last.at).toLocaleString()} FAILED: ${last.error}`
          : "No sweep has run yet since the backend started."}
      </p>

      <p className="toolbar-note">
        {data?.waiting?.length
          ? `Waiting: ${data.waiting.map((w) => `${w.name} (${Math.round(w.size / 1024)} KB)`).join(", ")}`
          : "Nothing waiting — normal between a pickup and Vision's next send."}
      </p>

      {!!data?.stuck?.length && (
        <div className="notice notice--warn">
          Left in <code>processing/</code>: {data.stuck.join(", ")}. A claim was
          made but the import did not finish — the file is kept as evidence
          rather than deleted. Worth looking at the backend log.
        </div>
      )}

      <div className="dept-add" style={{ background: "transparent", borderBottom: 0, paddingLeft: 0 }}>
        <button className="btn btn--primary" onClick={runNow} disabled={busy}>
          {busy ? "Checking…" : "Check for reports now"}
        </button>
      </div>
    </Card>
  );
}
